define('services/TagService',[
    'app',
    'modules/module',
    'services/EntityCrudService'
], function (app, module) {
    'use strict';
    return module.factory('TagService', [
        '$injector',
        TagService
    ]);
});


function TagService($injector) {

    crudInstance = $injector.instantiate(CrudService);
    crudInstance.setType('Tag');

    angular.extend(this, crudInstance);

    return this;
};
